import fleetAdminManagement from "./fleetAdminManagement.component";

const fleetAdminManagementModule = angular
  .module("app.components.fleetAdminManagement", [])
  .component("fleetAdminManagement", fleetAdminManagement);

export default fleetAdminManagementModule;



// WEBPACK FOOTER //
// ./src/components/fleetAdminManagement/fleetAdminManagement.module.js